import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((_nuxtApp) => {
  const router = useRouter();

  router.options.scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      const element = document.querySelector(to.hash);
      if (element) {
        smoothScrollTo(element, 1800); // Adjust duration (ms) as needed
        return false; // Prevent Vue Router’s default scroll
      }
    }

    return { top: 0, behavior: "smooth" };
  };
});

// Custom function for controlled smooth scrolling
function smoothScrollTo(element: Element, duration: number) {
  const targetPosition = element.getBoundingClientRect().top + window.scrollY - 30;
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;
  let startTime: number | null = null;

  function animation(currentTime: number) {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    window.scrollTo(0, startPosition + distance * easeInOutQuad(progress));

    if (progress < 1) {
      requestAnimationFrame(animation);
    }
  }

  function easeInOutQuad(t: number) {
    return t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2;
  }

  requestAnimationFrame(animation);
}
